import "./style.scss";

import CustomFieldsCollapse from "components/shared/CustomFieldsCollapse";
import NumberFormComponent from "components/shared/FormComponent/NumberFormComponent";
import TitleSeparation from "components/shared/TitleSeparation";
import { useTranslation } from "react-i18next";
import { ICustomField } from "store/customFieldsStore";

import CumulativeSalesArray from "./CumulativeSalesArray";

interface ILastYearInfoStep {
    /**
     * React useForm() hooks
     */
    useFormData: any;
    stepTitle: string;
    stepSubtitle: string;
    indexStep: number;
    /**
     * If title exist on an archived period
     */
    hasArchive?: boolean;
    /**
     * If company uses stocks or no
     */
    usesStocks: boolean;
}

const LastYearInfoStep = ({
    useFormData,
    stepTitle,
    stepSubtitle,
    indexStep,
    hasArchive,
    usesStocks,
}: ILastYearInfoStep) => {
    const [t] = useTranslation();
    const { control, errors, watch } = useFormData;

    return (
        <>
            <h3 className="form-section-title">
                {indexStep + 1}. {stepTitle}
            </h3>
            <span className="form-section-description">{stepSubtitle}</span>
            {hasArchive && <span className="form-section-info">{t("Titles.HasArchivesNonEditableData")}</span>}
            <div className="form-fields" style={{ gap: "4rem" }}>
                {usesStocks && (
                    <div className="form-quantity-field">
                        <TitleSeparation title={t("NewTitle.QuantityStock")} />
                        <NumberFormComponent
                            label={t("NewTitle.CopiesNumber")}
                            placeholder="0"
                            control={control}
                            controlName="initialInventory"
                            disabled={hasArchive}
                            disabledText={t("Titles.HasArchivesNonEditableData")}
                            hideDisabledLockIcon={hasArchive}
                            error={errors.initialInventory}
                        />
                    </div>
                )}

                {watch("startingChannelsData").length > 0 && (
                    <div className="form-cumulative-sales">
                        <TitleSeparation title={t("NewTitle.CumulativeSalesInfo")} />
                        <CumulativeSalesArray hasArchive={hasArchive} />
                    </div>
                )}
            </div>
        </>
    );
};

export default LastYearInfoStep;
